export default __webpack_public_path__ + "static/Castillo-bb2efe1115be28745d344fca6403cc71.jpg";